module.exports = __webpack_public_path__ + "img/order-setting.bfcc5380.svg";